var _style, _path, _path2, _ellipse, _ellipse2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAvatar3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "240.24px",
    height: "296px",
    viewBox: "0 0 240.24 296",
    style: {
      enableBackground: "new 0 0 240.24 296"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{stroke:#000000;stroke-width:2;stroke-miterlimit:10;}\r\n\t.st1{fill:#FFFFFF;stroke:#000000;stroke-width:2;stroke-miterlimit:10;}\r\n\t.st2{stroke:#FFFFFF;stroke-width:2;stroke-miterlimit:10;}\r\n\t.st3{fill:none;stroke:#000000;stroke-width:2;stroke-miterlimit:10;}\r\n\t.st4{fill:#B8B20F;}\r\n\t.st5{fill:#FFFF00;stroke:#000000;stroke-width:2;stroke-miterlimit:10;}\r\n\t.st6{fill:#1C77C9;stroke:#000000;stroke-width:2;stroke-miterlimit:10;}\r\n\t.st7{fill:#29ABE2;stroke:#000000;stroke-width:2;stroke-miterlimit:10;}\r\n\t.st8{fill:none;stroke:#000000;stroke-width:2;stroke-linecap:round;stroke-miterlimit:10;}\r\n\t.st9{fill:#FFFFFF;stroke:#FFFFFF;stroke-width:2;stroke-miterlimit:10;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M142.43,164.97c0.98-2.62,2.97-4.95,5.02-6.5c2.05-1.55,4.18-2.45,6.27-3.27c1.62-0.64,3.49-1.19,4.28,0.05 c0.9,1.43-0.2,4.27-1.28,6.58c-0.53,1.14-1.07,2.31-1.84,3.31c-0.76,1-1.8,1.8-2.64,1.76c1.75-0.45,3.49-0.89,5.24-1.34 c-2.01,2.78-4.67,4.91-7.17,5.74c2.21,0.21,4.64-0.17,7.12-1.11c-3.03,4.15-7.43,6.72-10.74,6.27"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M80.68,164.1c-0.79-2.32-2.69-4.23-4.72-5.4c-2.04-1.17-4.22-1.7-6.38-2.17c-1.67-0.37-3.62-0.62-4.57,0.66 c-1.1,1.48-0.2,3.99,0.71,6.01c0.45,1,0.92,2.02,1.63,2.85c0.72,0.83,1.74,1.44,2.64,1.28c-1.82-0.17-3.64-0.34-5.47-0.5 c1.87,2.33,4.5,3.95,7.09,4.37c-2.38,0.52-4.94,0.51-7.49-0.02c2.82,3.47,7.27,5.26,10.85,4.36"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9992 -0.0391 0.0391 0.9992 -6.6925 3.7693)",
    className: "st3",
    cx: 93.01,
    cy: 172.96,
    rx: 14.99,
    ry: 14.37
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9992 -0.0391 0.0391 0.9992 -6.6097 5.1789)",
    className: "st3",
    cx: 129.08,
    cy: 171.55,
    rx: 14.99,
    ry: 14.37
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M107.83,167.63c0.65-0.95,1.83-1.58,3.05-1.63c1.22-0.05,2.45,0.49,3.12,1.43c-0.06,0.81-0.22,1.61-0.47,2.39 c-0.55-0.77-1.57-1.25-2.58-1.19c-1.01,0.05-1.98,0.62-2.44,1.45c0.07-0.79-0.15-1.59-0.62-2.25c0.92-0.46,1.88-0.94,2.93-1.01 c1.05-0.08,2.21,0.35,2.6,1.24c-0.95-0.27-1.95-0.43-2.95-0.46c-0.36-0.01-0.74,0-1.08,0.13c-0.33,0.14-0.61,0.44-0.59,0.77 c0.77,0.15,1.56-0.1,2.35-0.21s1.71-0.02,2.15,0.58"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M108.1,175.69c0.71-0.93,2.01-1.46,3.24-1.31c1.23,0.14,2.33,0.94,2.75,2c0.17,0.43,0.24,0.88,0.44,1.3 c0.2,0.41,0.6,0.79,1.09,0.81c-1.42,2.58-2.85,5.16-4.27,7.74c-1.32-2.45-2.98-4.74-4.92-6.81c0.74-1.08,1.25-2.3,1.49-3.55"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M108.14,91.53c-1.31-1.77-3.17-3.11-5.26-3.8c-1.69,1.28-1.68,4.11-0.21,5.64c1.48,1.53,3.99,1.76,5.92,0.87 c3.3-1.52,4.68-6.04,3.04-9.28s-5.81-4.84-9.3-3.8c-3.48,1.04-6.05,4.41-6.43,8.03c-0.39,3.61,1.26,7.31,4,9.7 c2.09,1.82,4.94,2.96,7.65,2.42c4.81-0.95,7.28-6.5,7.39-11.4c0.13-5.5-2.38-11.67-7.6-13.39c-3.74-1.23-8,0.2-10.91,2.85 c-5.67,5.15-6.34,14.89-1.43,20.77c4.91,5.88,14.61,6.96,20.69,2.3c2.76-2.11,4.73-5.18,5.73-8.51c2.15-7.24-0.66-15.69-6.72-20.19 c-6.07-4.5-14.96-4.75-21.27-0.6c-6.31,4.16-9.59,12.43-7.85,19.78c2.12,8.94,10.85,15.21,19.91,16.77c6.5,1.12,13.91-0.1,18.23-5.1 c2.95-3.41,4.05-8.11,4.01-12.63c-0.06-7.74-3.47-15.64-9.81-20.07c-6.34-4.43-15.65-4.69-21.59,0.27"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M94.47,111.92c-0.19,1.97-0.37,3.94-0.56,5.91c7.46-0.53,14.93-1.06,22.39-1.59c0.11-2.14,0.23-4.29,0.34-6.43 c-7.26,0.75-14.52,1.5-21.78,2.24"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M94.98,118.9c-4.64-1.82-9.99-1.15-14.55,0.87c-4.56,2.02-8.44,5.3-12.03,8.76 c-23.61,22.8-36.7,56.08-34.96,88.85"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M90.34,120.38c-16.02,8.32-29.39,21.65-37.75,37.64S40.9,192.6,43.2,210.5"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M81.26,125.92c-24.3,21.51-37.5,54.95-34.44,87.25"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M60.42,175.24c-6.02,10.95-7.58,24.28-4.24,36.32"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M63.01,184.42c-4.29,9.33-4.48,20.45-0.52,29.92"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M68.45,187.53c-3.09,8.43-2.64,18.1,1.22,26.2c0.26-0.1,0.52-0.21,0.78-0.31"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M73.91,192.16c-1.47,5.32-1.87,10.93-1.18,16.4c0.14,1.1,0.34,2.24,0.96,3.16c0.62,0.92,1.78,1.56,2.85,1.26"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M92.53,119.61c-11.42,9.97-17.73,24.66-16.78,39.09"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M98.3,120.91c-5.43,4.16-8.64,10.69-10.09,17.37c-1.45,6.68-1.32,13.59-1.18,20.42"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M97.7,125.38c-5.25,8.46-7.3,18.86-5.65,28.68"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M102.18,121.74c-3.81,10.76-5.39,22.3-4.61,33.68c0.36-0.13,0.72-0.25,1.09-0.38"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M107.58,120.38c0.95,11.51,1.1,23.09,0.44,34.62"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M114.97,119.28c2.12,5.91,4.26,11.87,5.12,18.09c0.86,6.22,0.37,12.8-2.55,18.36"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M122.66,121.26c5.09,10.05,6.9,21.73,5.09,32.85"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M129.88,121.83c6.99,8.76,10.14,20.46,8.5,31.54"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M133.43,121.09c7.44,10.83,11.26,24.11,10.71,37.25c-0.13-0.85-0.27-1.7-0.4-2.56"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M139.53,125.41c5.32,7.84,8.6,17.54,9.31,27.5"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M153.88,136.67c11.13,20.16,15.48,44,12.18,66.8"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M118.15,115.87c20.03,4.51,37.92,17.77,48.06,35.62s12.37,40.01,6,59.52"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M160.76,163.44c2.78,11.42,3.21,23.4,1.25,34.98c-0.56,3.31-1.49,6.89-4.2,8.88"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M154.19,182.41c2.69,8.59,1.24,18.37-3.81,25.81"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M148.43,185.19c0.53,4.6,0.97,9.27,0.25,13.84c-0.72,4.57-2.73,9.1-6.34,12"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M75.66,181.24c-0.1,15.41,7.31,30.56,18.51,37.86s25.71,6.42,36.26-2.18s16.69-24.57,15.33-39.89"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatar3);
export default __webpack_public_path__ + "static/media/avatar3.9abd6495599564271f7fae7318d1e8ee.svg";
export { ForwardRef as ReactComponent };